// src/modules/app-views/customers/pages/Document/tabs/RecordTab/index.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleLoadingArea from 'components/SimpleComponents/SimpleLoadingArea';
import { useDocumentContext } from 'components/core/DocumentProvider';
import RegisterCard from './RegisterCard';
import EntityChannelsCard from 'components/core/entity/EntityChannelsCard';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const EntityRecordTab = ({
  setState,
  state = {},
  entityTypeModel,
  isHybridMode = false,
  ...restProps
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { data, loading } = useDocumentContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    // parent boundary for area loading
    <div className="container" style={{ position: 'relative', minHeight: 120 }}>
      <SimpleLoadingArea name="personalData" isFetching={loading} data={data} />

      <RegisterCard
        setState={setState}
        state={state}
        entityTypeModel={entityTypeModel}
        isHybridMode={isHybridMode}
      />

      <EntityChannelsCard />
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EntityRecordTab;

// *******************************************************************************
// HELPERS
// *******************************************************************************
